// eslint-disable-next-line no-shadow
export enum GenerationModelTypes {
	LIGHTNING = 'lightning',
	FLUX = 'flux',
}
